import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

@Component({
  selector: 'app-platform-avatar-placeholder',
  template: `
    <div class="wrapper" [style.background-color]="background()">
      <span>{{ initials() }}</span>
    </div>
  `,
  styleUrl: './platform-avatar-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformAvatarPlaceholderComponent {
  readonly initials = input<string>('');

  readonly backgroundColors = ['#EBE7E5', '#E4ECE6', '#E0E5EC', '#F4ECE1', '#EAE4EC'];
  readonly background = signal(
    this.backgroundColors[Math.floor(Math.random() * this.backgroundColors.length)]
  );
}
